import { InputLabel, MenuItem, Select, FormLabel, Tooltip, Container, Stack, Grid, Box, FormControlLabel, RadioGroup, FormControl, Radio, TextField, InputAdornment, Divider, Button } from "@mui/material";
import React, { useState, useEffect } from 'react';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Alert from '@mui/material/Alert';
import IdentidadEjemplo from './IdentidadEjemplo.jpg'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Aval from "./Components/aval1_simplificado";
import Aval2 from "./Components/aval2_simplificado";
import Autocomplete from '@mui/material/Autocomplete';
import dayjs from 'dayjs';
import axios from 'axios';
import CryptoJS from "crypto-js";
import 'dayjs/locale/es'; // Importa el archivo de localización para español
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Dialog, DialogTitle, DialogActions } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { post, postFiles } from "../../services/http";
import { ContextSession } from "../../services/ContextSession";
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import AutorizacionPDF from './archivos prestamo/Autorizacion.pdf'
import DownloadIcon from '@mui/icons-material/Download'; // Asegúrate de importar el icono

dayjs.locale('es'); // Establece el idioma local a español

async function sendDataSolicitud(accesos, ip, json, files, handleClose) {
    try {
        const data = new FormData();
        files.map((file) => {
            data.append(file.nombre, file.file);
        });
        data.append('FilesCount', files.length);
        data.append('data', JSON.stringify(json));

        let url = ip + "/api/nueva/";
        //let url = "http://172.20.7.10:8082/api/nueva/";

        let auto = "Bearer " + accesos;

        const response = await fetch(url, {
            method: "POST",
            body: data,
            headers: {
                "Authorization": auto
            }
        });

        const restData = await response.json();

        if (response.status !== 200) {
            throw new Error("Falla al comunicarnos con el servidor");
        }

        handleClose();
        return restData;
    } catch (error) {
        handleClose();
        console.error(error);
    }
}


function SolicitudSimplificada() {
    const isMobile = useMediaQuery('(max-width:820px)'); // Detectar si es una pantalla móvil
    const sessi = React.useContext(ContextSession);
    const [tipoPrestamo, setTipoPrestamo] = useState('all');
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [fechaVacia, setFechaVacia] = React.useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedAutorizacion, setSelectedAutorizacion] = useState(null);
    const [selectedAproximado, setSelectedAproximado] = useState(null);
    const [selectedAdeudado, setSelectedAdeudado] = useState(null);
    const [selectedIdentidadSoli, setSelectedIdentidadSoli] = useState(null);
    const [selectedIdentidadAval1, setselectedIdentidadAval1] = useState(null);
    const [selectedVoucherIdentidadAval1, setselectedVoucherIdentidadAval1] = useState(null);
    const [selectedIdentidadAval2, setselectedIdentidadAval2] = useState(null);
    const [selectedVoucherIdentidadAval2, setselectedVoucherIdentidadAval2] = useState(null);
    const [EstadoParticipante, setEstadoParticipante] = useState("");
    const [agregarAval2, setAgregarAval2] = React.useState('no'); // Estado para controlar la opción "Sí" o "No"
    const [edad, setEdad] = useState(null); // Estado para la edad

    useEffect(() => {
        const calcularEdad = () => {
            // Convertimos la fecha de nacimiento en un objeto Date
            const fechaNacimiento = new Date(selectedDate);
            const hoy = new Date(); // Obtenemos la fecha actual
            let edadCalculada = hoy.getFullYear() - fechaNacimiento.getFullYear(); // Calculamos la diferencia de años
            const mes = hoy.getMonth() - fechaNacimiento.getMonth(); // Comparamos los meses
            if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
                edadCalculada--; // Si aún no hemos cumplido años este año, restamos 1
            }
            setEdad(edadCalculada); // Establecemos el valor de la edad en el estado
        };

        calcularEdad(); // Llamamos a la función para calcular la edad al montar el componente
    }, [selectedDate]); // Se ejecuta cada vez que cambia selectedDate

    // Manejo del cambio del radio button aval2
    const handleRadioChange = (event) => {
        setAgregarAval2(event.target.value);
    };

    function CustomDatePickerNacimiento(props) {
        const today = dayjs();
        const [invalidFormat, setInvalidFormat] = React.useState(false);
        const [cleared, setCleared] = React.useState(false);

        React.useEffect(() => {
            if (cleared) {
                setSelectedDate(null);
                const timeout = setTimeout(() => {
                    setCleared(false);
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [cleared]);

        const handleDateChange = (date) => {
            if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
                setInvalidFormat(true);
            } else {
                setInvalidFormat(false);
                setSelectedDate(date);
                setFechaVacia(false);
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        readOnly
                        format={"DD/MM/YYYY"}
                        value={selectedDate}
                        views={['year', 'month', 'day']}
                        //onChange={handleDateChange}
                        onAccept={handleDateChange}
                        slotProps={{
                            field: {
                                clearable: true,
                                onClear: () => setCleared(true),
                                InputProps: {
                                    readOnly: true // Hacer el campo solo lectura
                                }
                            },
                            textField: {
                                variant: 'filled', // Cambiar la variante a 'filled'
                                helperText: fechaVacia ? 'Seleccione la fecha de nacimiento' : invalidFormat ? "Formato de fecha incorrecto" : (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: fechaVacia || invalidFormat,
                                onKeyDown: handleKeyDown
                            }
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>

        );
    }

    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ramo, setRamo] = useState('');
    const [dependencias, setDependencias] = useState([]);
    const secretKey = "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";

    useEffect(() => {
        // Obtener los datos del localStorage si existen
        const sessionData = JSON.parse(localStorage.getItem('sessionData'));

        if (sessionData) {
            sessi.sessionData = sessionData; // Restaurar los datos de sesión
        }

        // Ajustar el zoom del contenedor
        const container = document.getElementById('my-container');
        container.style.zoom = "90%";

        // Función para obtener dependencias
        const fetchDependencias = async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${sessi.ip}/api/dependencias/`, {});
                const instituciones = response.data.Instituciones;
                setDependencias(instituciones);
                const opciones = instituciones.map((inst, index) => `${index + 1}. ${inst.DSCEST.trim()}`);
                setOptions(opciones);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchDependencias();
    }, []); // Asegúrate de que se ejecute en la primera carga y recarga

    useEffect(() => {
        const sessionData = JSON.parse(localStorage.getItem('sessionData'));

        if (sessionData) {
            sessi.sessionData = sessionData; // Restaurar datos de sesión
        }

        setEstadoParticipante(sessi.sessionData.estado); // Setear el estado del participante

        async function fetchData() {
            const queryString = `dni=${sessi.sessionData.identidad}`;
            const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(CryptoJS.enc.Hex);

            setLoading(true);
            try {
                const dni = sessi.sessionData.identidad;
                const formData = new FormData();
                formData.append('dni', dni);

                const response = await fetch(`${sessi.ip}/api/datos/`, {
                    method: 'POST',
                    body: formData,
                    headers: {
                         "X-Signature": signature,
                    }
                });

                const data = await response.json();
                if (data && data.informacion) {
                    const info = data.informacion.reduce((acc, item) => {
                        const [key, value] = item.split(': ');
                        acc[key.trim()] = value ? value.trim() : '';
                        return acc;
                    }, {});

                    setFormData({
                        nombres: `${info.Nombre1 || ''} ${info.Nombre2 || ''}`,
                        apellidos: `${info.Apellido1 || ''} ${info.Apellido2 || ''}`,
                        fechaNacimiento: dayjs(info.FechaNacimiento, 'DD/MM/YYYY HH:mm:ss a'),
                    });
                    setSelectedDate(dayjs(info.FechaNacimiento, 'DD/MM/YYYY HH:mm:ss a'));
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []); // Asegúrate de que se ejecute en la primera carga y recarga

    // Guarda sessi.sessionData en el localStorage para persistencia
    useEffect(() => {
        if (sessi.sessionData) {
            localStorage.setItem('sessionData', JSON.stringify(sessi.sessionData));
        }
    }, [sessi.sessionData]);


    const [formData, setFormData] = useState({
        nombres: '',
        apellidos: '',
        fechaNacimiento: null,
    });

    const handleDependenciaChange = (event, value) => {
        const selectedDependencia = dependencias.find(inst => `${dependencias.indexOf(inst) + 1}. ${inst.DSCEST.trim()}` === value);
        if (selectedDependencia) {
            setRamo(selectedDependencia.RAMO);
        } else {
            setRamo('');
        }
    };

    function handleTipoPrestamo(event) {
        setTipoPrestamo(event.target.value);
    }

    const validarSoloNumeros = (event) => {
        // Solo permitir números
        event.target.value = event.target.value.replace(/[^0-9]/g, '');
    };

    const validarSoloNumerosTelefono = (event) => {
        let value = event.target.value;

        // Eliminar cualquier carácter que no sea un número
        value = value.replace(/[^0-9]/g, '');

        // Limitar la longitud del número a 8 dígitos
        if (value.length > 8) {
            value = value.slice(0, 8);
        }

        // Establecer el valor del campo de texto
        event.target.value = value;
    };

    const validarSoloLetras = (event) => {
        // Solo permitir letras, espacios y letras con acentos
        event.target.value = event.target.value.replace(/[^A-Za-zÁÉÍÓÚÜáéíóúü\s]/g, '');

        // Convertir a mayúsculas
        event.target.value = event.target.value.toUpperCase();
    };

    /*---------------------Validación Longitudes Y Campos Vacíos* ---------------*/

    const [errors, setErrors] = useState({});

    const handleBlur = (event) => {
        const fieldName = event.target.id;
        const fieldValue = event.target.value;
        let errorMessage = '';

        // Validación para la identidad
        if (fieldName === 'NumeroIdentidad') {
            if (fieldValue.length !== 13) {
                errorMessage = 'La identidad debe ser de 13 dígitos';
            }
        }

        // Validación para otros campos
        const fieldNamesToMessages = {
            Nombres: 'Ingrese los nombres del solicitante',
            Apellidos: 'Ingrese los apellidos del solicitante',
            DependenciaTrabajo: 'Ingrese la dependencia laboral del solicitante',
            sueldoMensualsoli: 'Ingrese el sueldo mensual del solicitante',
            otrosIngresossoli: 'Ingrese otros ingresos del solicitante',
            sueldoNetosoli: 'Ingrese el sueldo neto del solicitante',
            montosolicitado: 'Ingrese el monto a solicitar',
            Teléfono: 'Ingrese el número de teléfono'
        };

        if (fieldNamesToMessages.hasOwnProperty(fieldName)) {
            if (fieldValue.length < 1) {
                errorMessage = fieldNamesToMessages[fieldName];
            }
        }

        setErrors({
            ...errors,
            [fieldName]: errorMessage
        });
    };

    /*---------------------FINAL Validación Longitudes Y Campos Vacíos* ---------------*/

    const [value, setValue] = useState(''); // Valor interno del input sin comas

    const handleChange = (event) => {
        const { value: inputValue } = event.target;

        // Guardar el valor interno sin comas
        const numericValue = inputValue.replace(/[^0-9.]/g, '');

        // Establecer el valor interno
        setValue(numericValue);

        // Actualizar el valor del input con comas para mostrar
        const formattedValue = formatNumberWithCommas(numericValue);
        event.target.value = formattedValue;
    };

    const formatNumberWithCommas = (numberString) => {
        // Separar las partes antes y después del punto decimal
        const parts = numberString.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join('.');
    };

    const validateErrors = (props) => {

        // Obtener todos los elementos de entrada dentro del formulario
        const inputFields = document.querySelectorAll('input');
        const files = [];
        // Objeto para almacenar los valores de los campos de entrada
        const fieldValues = {};

        // Iterar sobre los elementos de entrada y obtener sus valores
        inputFields.forEach(input => {
            fieldValues[input.id] = input.value;
        });

        // Objeto para almacenar los mensajes de error
        let errorMessages = {};

        if (tipoPrestamo === 'all') {
            errorMessages[0] = '-Seleccione el tipo de préstamo a solicitar en el inicio del formulario.'
        } else {
            fieldValues["tipoDePrestamo"] = tipoPrestamo;

            if (!selectedFile) {
                errorMessages['selectedFile'] = '-Adjunte vouchers de pago del solicitante en formato PDF';
            }

            if (tipoPrestamo === "Alivio de Deuda" && (EstadoParticipante !== "JUBILADO" || EstadoParticipante !== "PENSIONADO")) {
                if (!selectedAproximado) {
                    errorMessages['selectedAproximado'] = '-Adjunte cálculo aproximado de prestaciones laborales del solicitante en formato PDF';
                }
            }

            if (tipoPrestamo === "Alivio de Deuda" || tipoPrestamo === "Consolidacion de Deuda") {
                if (!selectedAdeudado) {
                    errorMessages['selectedAdeudado'] = '-Adjunte estados de cuenta de lo adeudado en formato PDF';
                }
            }

            // Ejecutar la lógica de validación para cada campo
            Object.entries(fieldValues).forEach(([fieldName, fieldValue]) => {
                let errorMessage = '';

                if (!selectedDate) {
                    errorMessages['FechaNacimiento'] = '-Seleccione la fecha de nacimiento del solicitante';
                    setFechaVacia(true);
                }

                if (!selectedIdentidadSoli) {
                    errorMessages['selectedIdentidadSoli'] = '-Adjunte identidad del solicitante en formato PDF';
                }

                if (fieldName === 'NumeroIdentidad') {
                    if (fieldValue.length !== 13) {
                        errorMessage = '-La identidad del solicitante debe ser de 13 dígitos';
                    }
                }

                if (tipoPrestamo === 'Con Aval' || tipoPrestamo === 'Consolidacion de Deuda') {

                    if (!selectedIdentidadAval1) {
                        errorMessages['selectedIdentidadAval1'] = '-Adjunte identidad del aval 1 en formato PDF';
                    }

                    if (!selectedVoucherIdentidadAval1) {
                        errorMessages['selectedVoucherIdentidadAval1'] = '-Adjunte vouchers de pago del aval 1 en formato PDF';
                    }

                    if (agregarAval2 === "si") {
                        if (!selectedIdentidadAval2) {
                            errorMessages['selectedIdentidadAval2'] = '-Adjunte identidad del aval 2 en formato PDF';
                        }


                        if (!selectedVoucherIdentidadAval2) {
                            errorMessages['selectedVoucherIdentidadAval2'] = '-Adjunte vouchers de pago del aval 2 en formato PDF';
                        }
                    }

                }

                if (tipoPrestamo === 'Hipotecario') {
                    if (tipoHipotecario === '' || tipoHipotecario === null) {
                        errorMessages['tipoHipotecario'] = '-Seleccione el tipo de préstamo hipotecario';
                    }

                    if (!selectedAutorizacion) {
                        errorMessages['selectedAutorizacion'] = '-Adjunte autorización de referencias en la central crediticia en formato PDF';
                    }

                    if (fieldName === 'Teléfono') {
                        if (fieldValue.length === 0) {
                            errorMessage = '-Debe ingresar el número de teléfono';
                        }

                        if (fieldValue.length !== 8) {
                            errorMessage = '-El teléfono debe ser de 8 dígitos';
                        }
                    }

                }

                // Validación para otros campos
                const fieldNamesToMessages = {
                    //---------------SOLICITANTE----------------------------
                    Nombres: '-Ingrese los nombres del solicitante',
                    Apellidos: '-Ingrese los apellidos del solicitante',
                    //FechaNacimiento: '-Ingrese fecha de nacimiento del solicitante',
                    DependenciaTrabajo: '-Ingrese la dependencia laboral del solicitante',
                    sueldoMensualsoli: '-Ingrese el sueldo mensual del solicitante',
                    otrosIngresossoli: '-Ingrese otros ingresos del solicitante',
                    sueldoNetosoli: '-Ingrese el sueldo neto del solicitante',
                    montosolicitado: '-Ingrese el monto a solicitar',
                    Teléfono: '-Ingrese el número de teléfono'
                };

                if (fieldNamesToMessages.hasOwnProperty(fieldName)) {
                    if (fieldValue.length < 1) {
                        errorMessage = fieldNamesToMessages[fieldName];
                    }
                }

                errorMessages[fieldName] = errorMessage;
            });
        }

        // Actualizar el estado de los errores
        setErrors(errorMessages);

        // Verificar si hay errores después de ejecutar la validación
        const hasErrors = Object.values(errorMessages).some(error => error !== '');
        if (hasErrors) {
            setOpenDialogErrores(true);
        } else {
            // Generar JSON con los datos del formulario
            files.push({ nombre: "SolDni", file: selectedIdentidadSoli });
            files.push({ nombre: "Aval1dni", file: selectedIdentidadAval1 });
            files.push({ nombre: "Aval1Voucher", file: selectedVoucherIdentidadAval1 });
            files.push({ nombre: "Aval2dni", file: selectedIdentidadAval2 });
            files.push({ nombre: "Aval2Voucher", file: selectedVoucherIdentidadAval2 });
            files.push({ nombre: "voucher", file: selectedFile });
            files.push({ nombre: "PrestacionesAproximado", file: selectedAproximado });
            files.push({ nombre: "EstadoDeudas", file: selectedAdeudado });
            files.push({ nombre: "CentralRiesgos", file: selectedAutorizacion });
            const jsonOutput = {
                "solicitud_prestamo": {
                    "NumeroSolicitud": null,
                    "NumeroCotizante": null,//document.getElementById("SolicitanteID").value,
                    "TipoPrestamo": tipoPrestamo,
                    //"FechaSolicitud": new Date().toISOString().split('T')[0],
                    "UsuarioID": sessi.sessionData.id,
                    "Estado": "Nuevo",
                    "MontoSolicitado": document.getElementById("montosolicitado") ? document.getElementById("montosolicitado").value.replace(/\D/g, '') : null,
                    "DetalleParticipante": document.getElementById("ComentarioParticipante").value,
                    "observacion": null,
                    "aprobado": null,
                    "asignado": null,
                    "EstadoParticipante": EstadoParticipante,
                    "TipoHipotecario": tipoHipotecario
                },
                "datos_solicitante": {
                    "NumeroIdentidad": document.getElementById("NumeroIdentidad").value,
                    "Nombres": document.getElementById("Nombres").value,
                    "Apellidos": document.getElementById("Apellidos").value,
                    "FechaNacimiento": selectedDate.toISOString().split('T')[0],
                    "Profesion": null,
                    "TipoVivienda": null,
                    "Direccion": null,
                    "BarrioCol": null,
                    "Ave": null,
                    "Calle": null,
                    "CasaNo": null,
                    "Ciudad": null,
                    "Departamento": null,
                    "EstadoCivil": null,
                    "ReferenciaDomicilio": null,
                    "TelefonoFijo": null,
                    "TelefonoMovil": document.getElementById("Teléfono") ? (document.getElementById("Teléfono").value.trim() || null) : null,
                    "CorreoElectronico": null,
                    "ArchivoPDF": "Identidad.pdf"
                },
                "referencias_personales": [
                    {
                        "Nombre": null,
                        "Parentesco": null,
                        "Direccion": null,
                        "Telefono": null,
                    },
                    {
                        "Nombre": null,
                        "Parentesco": null,
                        "Direccion": null,
                        "Telefono": null,
                    }
                ],
                "transferencia_pago": {
                    "TipoCuenta": null,
                    "Banco": null,
                    "NoCuenta": null
                },
                "deudas_consolidar": [
                    {
                        "InstitucionFinanciera": null,
                        "MontoLempiras": null,
                        "MontoDolares": null,
                        "TotalLempiras": null,
                        "ConsolidacionTotal": null,
                        "ConsolidacionParcial": null,
                    },
                    {
                        "InstitucionFinanciera": null,
                        "MontoLempiras": null,
                        "MontoDolares": null,
                        "TotalLempiras": null,
                        "ConsolidacionTotal": null,
                        "ConsolidacionParcial": null,
                    },
                    {
                        "InstitucionFinanciera": null,
                        "MontoLempiras": null,
                        "MontoDolares": null,
                        "TotalLempiras": null,
                        "ConsolidacionTotal": null,
                        "ConsolidacionParcial": null,
                    },
                    {
                        "InstitucionFinanciera": null,
                        "MontoLempiras": null,
                        "MontoDolares": null,
                        "TotalLempiras": null,
                        "ConsolidacionTotal": null,
                        "ConsolidacionParcial": null,
                    },
                    {
                        "InstitucionFinanciera": null,
                        "MontoLempiras": null,
                        "MontoDolares": null,
                        "TotalLempiras": null,
                        "ConsolidacionTotal": null,
                        "ConsolidacionParcial": null,
                    },
                ],
                "voucher_pago": {
                    "ArchivoPDF": "VouchersPago.pdf"
                }
            };

            if (EstadoParticipante !== "JUBILADO" && EstadoParticipante !== "PENSIONADO") {
                jsonOutput.informacion_laboral =
                {
                    "DependenciaTrabajo": document.getElementById("DependenciaTrabajo").value,
                    "Ramo": null,
                    "Telefono": null,
                    "Direccion": null,
                    "BarrioCol": null,
                    "Ave": null,
                    "Calle": null,
                    "CasaNo": null,
                    "Ciudad": null,
                    "Departamento": null,
                    "SueldoMensual": document.getElementById("sueldoMensualsoli").value,
                    "OtrosIngresos": document.getElementById("otrosIngresossoli").value,
                    "SueldoNeto": document.getElementById("sueldoNetosoli").value,
                    "Puesto": null,
                    "TiempoLaborarAnios": null,
                    "TiempoLaborarMeses": null
                }

            }

            // Condiciona la inclusión de las secciones opcionales
            if (tipoPrestamo === 'Con Aval' || tipoPrestamo === 'Consolidacion de Deuda') {
                jsonOutput.datos_aval = [
                    {
                        "NumeroIdentidad": null,
                        "Nombres": null,
                        "Apellidos": null,
                        "FechaNacimiento": null,
                        "Profesion": null,
                        "TipoVivienda": null,
                        "Direccion": null,
                        "BarrioCol": null,
                        "Ave": null,
                        "Calle": null,
                        "CasaNo": null,
                        "Ciudad": null,
                        "Departamento": null,
                        "EstadoCivil": null,
                        "ReferenciaDomicilio": null,
                        "TelefonoFijo": null,
                        "TelefonoMovil": null,
                        "CorreoElectronico": null,
                        "ArchivoPDF": "IdentidadAval1.pdf"
                    },
                    {
                        "NumeroIdentidad": null,
                        "Nombres": null,
                        "Apellidos": null,
                        "FechaNacimiento": null,
                        "Profesion": null,
                        "TipoVivienda": null,
                        "Direccion": null,
                        "BarrioCol": null,
                        "Ave": null,
                        "Calle": null,
                        "CasaNo": null,
                        "Ciudad": null,
                        "Departamento": null,
                        "EstadoCivil": null,
                        "ReferenciaDomicilio": null,
                        "TelefonoFijo": null,
                        "TelefonoMovil": null,
                        "CorreoElectronico": null,
                        "ArchivoPDF": "IdentidadAval2.pdf"
                    }
                ];
                jsonOutput.informacion_laboral_aval = [
                    {
                        "DependenciaTrabajo": null,
                        "Ramo": null,
                        "Telefono": null,
                        "Direccion": null,
                        "BarrioCol": null,
                        "Ave": null,
                        "Calle": null,
                        "CasaNo": null,
                        "Ciudad": null,
                        "Departamento": null,
                        "SueldoMensual": null,
                        "OtrosIngresos": null,
                        "SueldoNeto": null,
                        "Puesto": null,
                        "TiempoLaborarAnios": null,
                        "TiempoLaborarMeses": null
                    },
                    {
                        "DependenciaTrabajo": null,
                        "Ramo": null,
                        "Telefono": null,
                        "Direccion": null,
                        "BarrioCol": null,
                        "Ave": null,
                        "Calle": null,
                        "CasaNo": null,
                        "Ciudad": null,
                        "Departamento": null,
                        "SueldoMensual": null,
                        "OtrosIngresos": null,
                        "SueldoNeto": null,
                        "Puesto": null,
                        "TiempoLaborarAnios": null,
                        "TiempoLaborarMeses": null
                    }
                ];
            }

            //console.log(jsonOutput);
            let token = sessi.sessionData.token;
            handleOpen(true);
            sendDataSolicitud(token, sessi.ip, jsonOutput, files, handleClose);
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedFile(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleFileChangeAproximado = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedAproximado(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleFileChangeAdeudado = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedAdeudado(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleFileChangeIdentidadSoli = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedIdentidadSoli(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleFileAutorizacion = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedAutorizacion(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDragOverAproximado = (event) => {
        event.preventDefault();
    };

    const handleDragOverAdeudado = (event) => {
        event.preventDefault();
    };

    const handleDragOverIdentidadSoli = (event) => {
        event.preventDefault();
    };

    const handleDragOverAutorizacion = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedFile(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleDropAproximado = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedAproximado(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleDropAdeudado = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedAdeudado(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleDropIdentidadSoli = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedIdentidadSoli(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleDropAutorizacion = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedAutorizacion(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleClick = () => {
        document.getElementById('fileInput').click();
    };

    const handleClickAproximado = () => {
        document.getElementById('aproximado').click();
    };

    const handleClickAdeudado = () => {
        document.getElementById('adeudado').click();
    };

    const handleClickIdentidadSoli = () => {
        document.getElementById('selectedIdentidadSoli').click();
    };

    const handleClickAutorizacion = () => {
        document.getElementById('selectedAutorizacion').click();
    };

    const [open, setOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogErrores, setOpenDialogErrores] = useState(false);
    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        navigate('/Mis Solicitudes/MisSolicitudes');
    };

    const handleCloseDialogErrores = () => {
        setOpenDialogErrores(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const [tipoHipotecario, setTipoHipotecario] = React.useState('');

    const handleChangeHipotecario = (event) => {
        setTipoHipotecario(event.target.value);
    };

    return (<>
        <div id="my-container">
            <Container style={{ marginTop: isMobile ? 1 : 50 }} >
                {/* <Stack direction="row">
                    <Grid spacing={2} container>
                        <Grid item xs={10} md={2.2} >
                            {<img style={{ width: 200, height: 'auto' }} src={logoblack} />}
                        </Grid>
                        <Grid style={{ textAlign: 'center' }} item xs={4} md={5.8}>
                            <h1>SOLICITUD DE PREANÁLISIS DE PRÉSTAMO</h1>
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <Stack>
                                <Box>
                                    <label style={{ marginRight: 10, visibility: 'hidden' }}>No. Solicitud: </label>
                                    <TextField id="SolicitudID" variant="standard" InputProps={{
                                        readOnly: true,
                                        style: { visibility: 'hidden' }
                                    }} />
                                </Box>
                                <Box>
                                    <label style={{ marginRight: 10, visibility: 'hidden' }}>No. Cotizante:</label>
                                    <TextField id="SolicitanteID" variant="standard" style={{ visibility: 'hidden' }} />
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </Stack>*/}
                <Grid container justify="center" alignItems="center" >
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <h1>SOLICITUD DE PREANÁLISIS DE PRÉSTAMO</h1>
                    </Grid>
                </Grid>
                <Stack
                    direction={isMobile ? 'column' : 'row'} // Cambiar dirección según el tamaño de pantalla
                    alignItems="center"
                    spacing={2} // Espaciado entre los elementos
                >
                    <label style={{ marginRight: isMobile ? 0 : 20 }}>TIPO DE PRÉSTAMO:</label>
                    <FormControl component="fieldset">
                        <RadioGroup
                            id="grupoTipoPrestamo"
                            onChange={handleTipoPrestamo}
                            row={!isMobile} // Solo mostrar en fila si no es móvil
                            aria-labelledby="Tipo Prestamo"
                            name="tipoPrestamo"
                        >
                            <FormControlLabel value="Sin Aval" control={<Radio color="error" variant="solid" />} label="Sin Aval" />
                            <FormControlLabel value="Con Aval" control={<Radio color="error" />} label="Con Aval" />
                            <FormControlLabel value="Consolidacion de Deuda" control={<Radio color="error" />} label="Consolidacion de Deuda" />
                            <FormControlLabel value="Alivio de Deuda" control={<Radio color="error" />} label="Alivio de Deuda" />
                            <FormControlLabel value="Refinanciamiento" control={<Radio color="error" />} label="Refinanciamiento" />
                            <FormControlLabel value="Hipotecario" control={<Radio color="error" />} label="Hipotecario" />
                        </RadioGroup>
                    </FormControl>
                </Stack>
                <Divider />
                {tipoPrestamo === "Hipotecario" && (
                    <>
                        <Stack
                            direction={isMobile ? 'column' : 'row'} // Cambiar dirección según el tamaño de pantalla
                            alignItems="center"
                            spacing={2} // Espaciado entre los elementos
                            style={{ marginTop: 15 }}
                        >
                            <h3 style={{ textAlign: 'center' }}>Seleccione el tipo de Hipotecario:</h3>
                            <Box>
                                <FormControl sx={{ m: 1, width: isMobile ? 320 : 400 }}>
                                    <InputLabel id="demo-simple-select-label">Tipo Hipotecario</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={tipoHipotecario}
                                        label="Tipo Hipotecario"
                                        onChange={handleChangeHipotecario}
                                    >
                                        <MenuItem value="Compra de vivienda, condominio o apartamento">Compra de vivienda, condominio o apartamento</MenuItem>
                                        <MenuItem value="Compra de terreno">Compra de terreno</MenuItem>
                                        <MenuItem value="Liberación de Gravamen Hipotecario">Liberación de Gravamen Hipotecario</MenuItem>
                                        <MenuItem value="Construcción de vivienda">Construcción de vivienda</MenuItem>
                                        <MenuItem value="Mejora de vivienda">Mejora de vivienda</MenuItem>
                                        <MenuItem value="Otros préstamos con garantía hipotecaria">Otros préstamos con garantía hipotecaria</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </Stack>

                    </>
                )}
                {tipoPrestamo !== 'Hipotecario' && (
                    <Stack
                        direction={isMobile ? 'column' : 'row'} // Cambiar dirección según el tamaño de pantalla
                        alignItems="center"
                        spacing={2} // Espaciado entre los elementos
                        marginTop={3}
                    >
                        <h3 style={{ marginRight: isMobile ? 0 : 10 }}>MONTO A SOLICITAR:</h3>
                        <FormControl sx={{ m: 1, width: isMobile ? '100%' : 200 }}>
                            <TextField
                                id="montosolicitado"
                                value={formatNumberWithCommas(value)} // Mostrar el valor formateado
                                onChange={handleChange} // Manejar el cambio de valor
                                variant={isMobile ? "outlined" : "standard"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            L.
                                        </InputAdornment>
                                    ),
                                    inputMode: 'numeric', // Esto ayuda en dispositivos móviles
                                    type: 'tel', // Esto sugiere al navegador que es un campo numérico
                                }}
                                error={Boolean(errors.montosolicitado)}
                                onBlur={handleBlur}
                                helperText={errors.montosolicitado}
                            />
                        </FormControl>

                    </Stack>
                )}

                <Stack
                    direction="column" // Siempre en columna
                    alignItems="flex-start" // Alinea los elementos al inicio del contenedor
                    spacing={2} // Espaciado entre los elementos
                    marginTop={3}
                >
                    <h3 style={{ textAlign: 'center' }}>Comentarios sobre su solicitud (opcional):</h3>
                    <FormControl sx={{ m: 1, width: '100%' }}>
                        <TextField
                            label="Ingrese su comentario aquí"
                            id="ComentarioParticipante"
                            multiline
                            rows={4}
                            variant="outlined"
                        />
                    </FormControl>
                </Stack>

                <Divider style={{ marginTop: 20 }} />
                <Box marginTop={2}>
                    <Stack direction="row">
                        <h3>I. DATOS DEL SOLICITANTE</h3>
                    </Stack>

                    <Stack direction={isMobile ? 'column' : 'row'} mt={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="NumeroIdentidad"
                                        label="Número de Identidad"
                                        variant="filled"
                                        onInput={validarSoloNumeros}
                                        value={sessi.sessionData.identidad}
                                        inputProps={{ maxLength: 13 }} // Limitar la longitud máxima a 13 caracteres
                                        error={Boolean(errors.NumeroIdentidad)}
                                        onBlur={handleBlur}
                                        helperText={errors.NumeroIdentidad}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="Nombres"
                                        label="Nombres"
                                        variant="filled"
                                        onInput={validarSoloLetras}
                                        value={formData.nombres}
                                        error={Boolean(errors.Nombres)}
                                        onBlur={handleBlur}
                                        helperText={errors.Nombres}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="Apellidos"
                                        label="Apellidos"
                                        variant="filled"
                                        onInput={validarSoloLetras}
                                        value={formData.apellidos}
                                        error={Boolean(errors.Apellidos)}
                                        onBlur={handleBlur}
                                        helperText={errors.Apellidos}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl fullWidth>
                                    <CustomDatePickerNacimiento id='FechaNacimiento' label="Fecha Nacimiento" />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="Edad"
                                        label="Edad"
                                        value={`${edad} años`}
                                        variant="filled"
                                    />
                                </FormControl>
                            </Grid>
                            {tipoPrestamo === "Hipotecario" && (
                                <Grid item xs={12} sm={6} md={4}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="Teléfono"
                                            label="Ingrese su Número de Teléfono"
                                            variant="outlined"
                                            inputProps={{
                                                pattern: "[0-9]*",  // Asegura que solo se puedan ingresar números
                                                inputMode: "numeric", // Establece el teclado numérico en dispositivos móviles
                                            }}
                                            onInput={validarSoloNumerosTelefono} // Filtra los caracteres no numéricos
                                            error={Boolean(errors.Teléfono)}
                                            onBlur={handleBlur}
                                            helperText={errors.Teléfono}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        </Grid>
                    </Stack>
                </Box>
                <Divider style={{ marginTop: 5 }} />
                <Box marginTop={5}>
                    <h3>II. COPIA DE LA IDENTIDAD DEL SOLICITANTE EN FORMATO PDF</h3>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        onDragOver={handleDragOverIdentidadSoli}
                        onDrop={handleDropIdentidadSoli}
                    >
                        <Box
                            style={{
                                padding: '50px',
                                width: isMobile ? '300px' : '700px',
                                textAlign: 'center',
                                borderColor: selectedIdentidadSoli ? 'green' : '#a0a0a0',
                                borderRadius: 5,
                                borderWidth: 5,
                                borderStyle: 'dashed',
                            }}
                        >
                            <Tooltip
                                title={
                                    <div style={{ textAlign: 'center' }}>
                                        <p style={{ fontSize: 15, textAlign: 'justify' }}>El archivo pdf debe contener la tarjeta de identidad por ambos lados de la siguiente forma:</p>
                                        <img src={IdentidadEjemplo} alt="Identidad Ejemplo" style={{ width: '200px', height: 'auto' }} />
                                    </div>
                                }
                                interactive="true" // Cambiado a cadena en lugar de valor booleano
                            >
                                <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                            </Tooltip>
                            <br />
                            <Button
                                variant="contained"
                                onClick={handleClickIdentidadSoli}
                                style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                            >
                                Seleccionar Identidad En PDF
                            </Button>
                            <input
                                id="selectedIdentidadSoli"
                                type="file"
                                accept=".pdf"
                                style={{ display: 'none' }}
                                onChange={handleFileChangeIdentidadSoli}
                            />
                            {!selectedIdentidadSoli && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                            {selectedIdentidadSoli && <p>Archivo seleccionado: {selectedIdentidadSoli.name}</p>}
                        </Box>
                    </Box>
                </Box>

                <Box marginTop={5}>
                    {<h3>III. VOUCHERS DE PAGO DEL SOLICITANTE EN FORMATO PDF</h3>}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                    >
                        <Box
                            style={{
                                padding: '50px',
                                width: isMobile ? '300px' : '700px',
                                textAlign: 'center',
                                borderColor: selectedFile ? 'green' : '#a0a0a0',
                                borderRadius: 5,
                                borderWidth: 5,
                                borderStyle: 'dashed',
                            }}
                        >
                            <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                            <br />
                            <Button
                                variant="contained"
                                onClick={handleClick}
                                style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                            >
                                Seleccionar Archivo PDF
                            </Button>
                            <input
                                id="fileInput"
                                type="file"
                                accept=".pdf"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                            {!selectedFile && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                            {selectedFile && <p>Archivo seleccionado: {selectedFile.name}</p>}
                        </Box>
                    </Box>
                </Box>

                {tipoPrestamo === "Hipotecario" && (
                    <Box marginTop={5}>
                        <h3>IV. AUTORIZACIÓN DE REFERENCIAS EN LA CENTRAL DE INFORMACIÓN CREDITICIA EN FORMATO PDF</h3>

                        {/* Instrucción y botón con icono de descarga */}
                        <Box marginBottom={2}>
                            <p>Descargue la autorización, la cual deberá ser llenada y firmada para posteriormente ser adjunta en el siguiente campo.</p>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<DownloadIcon />}
                                onClick={() => window.open(AutorizacionPDF, "_blank")}
                                style={{ textTransform: 'none' }}
                            >
                                Pulse aquí para descargar la autorización
                            </Button>
                        </Box>

                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            onDragOver={handleDragOverAutorizacion}
                            onDrop={handleDropAutorizacion}
                        >
                            <Box
                                style={{
                                    padding: '50px',
                                    width: isMobile ? '300px' : '700px',
                                    textAlign: 'center',
                                    borderColor: selectedAutorizacion ? 'green' : '#a0a0a0',
                                    borderRadius: 5,
                                    borderWidth: 5,
                                    borderStyle: 'dashed',
                                }}
                            >
                                <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                                <br />
                                <Button
                                    variant="contained"
                                    onClick={handleClickAutorizacion}
                                    style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                                >
                                    Seleccionar Archivo PDF
                                </Button>
                                <input
                                    id="selectedAutorizacion"
                                    type="file"
                                    accept=".pdf"
                                    style={{ display: 'none' }}
                                    onChange={handleFileAutorizacion}
                                />
                                {!selectedAutorizacion && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                                {selectedAutorizacion && <p>Archivo seleccionado: {selectedAutorizacion.name}</p>}
                            </Box>
                        </Box>
                    </Box>
                )}


                {(tipoPrestamo === "Alivio de Deuda" && (EstadoParticipante !== "JUBILADO" && EstadoParticipante !== "PENSIONADO")) && <>
                    <Box marginTop={5}>
                        {<h3>IV. CÁLCULO APROXIMADO DE PRESTACIONES LABORALES DEL SOLICITANTE EN FORMATO PDF</h3>}
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            onDragOver={handleDragOverAproximado}
                            onDrop={handleDropAproximado}
                        >
                            <Box
                                style={{
                                    padding: '50px',
                                    width: isMobile ? '300px' : '700px',
                                    textAlign: 'center',
                                    borderColor: selectedAproximado ? 'green' : '#a0a0a0',
                                    borderRadius: 5,
                                    borderWidth: 5,
                                    borderStyle: 'dashed',
                                }}
                            >
                                <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                                <br />
                                <Button
                                    variant="contained"
                                    onClick={handleClickAproximado}
                                    style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                                >
                                    Seleccionar Archivo PDF
                                </Button>
                                <input
                                    id="aproximado"
                                    type="file"
                                    accept=".pdf"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChangeAproximado}
                                />
                                {!selectedAproximado && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                                {selectedAproximado && <p>Archivo seleccionado: {selectedAproximado.name}</p>}
                            </Box>
                        </Box>
                    </Box>
                </>
                }

                {(tipoPrestamo === "Alivio de Deuda" || tipoPrestamo === "Consolidacion de Deuda") && <>
                    <Box marginTop={5}>
                        {<h3>ESTADOS DE CUENTA DE LO ADEUDADO EN FORMATO PDF</h3>}
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            onDragOver={handleDragOverAdeudado}
                            onDrop={handleDropAdeudado}
                        >
                            <Box
                                style={{
                                    padding: '50px',
                                    width: isMobile ? '300px' : '700px',
                                    textAlign: 'center',
                                    borderColor: selectedAdeudado ? 'green' : '#a0a0a0',
                                    borderRadius: 5,
                                    borderWidth: 5,
                                    borderStyle: 'dashed',
                                }}
                            >
                                <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                                <br />
                                <Button
                                    variant="contained"
                                    onClick={handleClickAdeudado}
                                    style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                                >
                                    Seleccionar Archivo PDF
                                </Button>
                                <input
                                    id="adeudado"
                                    type="file"
                                    accept=".pdf"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChangeAdeudado}
                                />
                                {!selectedAdeudado && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                                {selectedAdeudado && <p>Archivo seleccionado: {selectedAdeudado.name}</p>}
                            </Box>
                        </Box>
                    </Box>
                </>
                }

                {(EstadoParticipante !== "JUBILADO" && EstadoParticipante !== "PENSIONADO") && (
                    <Box marginTop={5}>
                        <Stack direction="row">
                            <h3 >INFORMACIÓN LABORAL (participantes activos)</h3>
                        </Stack>

                        <Stack direction="row">
                            <Grid container>
                                <FormControl sx={{ m: 1, width: 350 }}>
                                    <Autocomplete
                                        id="DependenciaTrabajo"
                                        options={options}
                                        loading={loading}
                                        onChange={handleDependenciaChange}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Dependencia donde Trabaja"
                                                variant="standard"
                                                error={Boolean(errors.DependenciaTrabajo)}
                                                onBlur={handleBlur}
                                                helperText={errors.DependenciaTrabajo}
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl sx={{ m: 1, width: !isMobile ? 200 : 350 }}>
                                    <TextField
                                        id="sueldoMensualsoli"
                                        label="Sueldo Mensual"
                                        variant="standard"
                                        onInput={validarSoloNumeros /*validarSoloNumerosComa*/}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    L.
                                                </InputAdornment>
                                            ),
                                            inputMode: 'numeric', // Esto ayuda en dispositivos móviles
                                            type: 'tel', // Esto sugiere al navegador que es un campo numérico
                                        }}
                                        error={Boolean(errors.sueldoMensualsoli)}
                                        onBlur={handleBlur}
                                        helperText={errors.sueldoMensualsoli}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: !isMobile ? 200 : 350 }}>
                                    <TextField
                                        id="otrosIngresossoli"
                                        label="Otros Ingresos (detalle)"
                                        variant="standard"
                                        onInput={validarSoloNumeros /*validarSoloNumerosComa*/}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    L.
                                                </InputAdornment>
                                            ),
                                            inputMode: 'numeric', // Esto ayuda en dispositivos móviles
                                            type: 'tel', // Esto sugiere al navegador que es un campo numérico
                                        }}
                                        error={Boolean(errors.otrosIngresossoli)}
                                        onBlur={handleBlur}
                                        helperText={errors.otrosIngresossoli}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: !isMobile ? 200 : 350 }}>
                                    <TextField
                                        id="sueldoNetosoli"
                                        label="Sueldo Neto"
                                        variant="standard"
                                        onInput={validarSoloNumeros /*validarSoloNumerosComa*/}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    L.
                                                </InputAdornment>
                                            ),
                                            inputMode: 'numeric', // Esto ayuda en dispositivos móviles
                                            type: 'tel', // Esto sugiere al navegador que es un campo numérico
                                        }}
                                        error={Boolean(errors.sueldoNetosoli)}
                                        onBlur={handleBlur}
                                        helperText={errors.sueldoNetosoli}
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>
                    </Box>
                )}
                <Divider style={{ marginTop: 5 }} />

                {(tipoPrestamo === "Con Aval" || tipoPrestamo === "Consolidacion de Deuda" || tipoPrestamo === "all") && <>
                    <Aval
                        selectedIdentidadAval1={selectedIdentidadAval1}
                        setselectedIdentidadAval1={setselectedIdentidadAval1}
                        selectedVoucherIdentidadAval1={selectedVoucherIdentidadAval1}
                        setselectedVoucherIdentidadAval1={setselectedVoucherIdentidadAval1}
                    />
                    <Divider style={{ marginTop: 5 }} />
                </>
                }

                {(tipoPrestamo === "Con Aval" || tipoPrestamo === "Consolidacion de Deuda" || tipoPrestamo === "all") && <>
                    <Box marginTop={5}>
                        <h3>Aval 2 (Opcional)</h3>
                        <FormControl component="fieldset">
                            <FormLabel>¿Agregar Aval 2?</FormLabel>
                            <RadioGroup row value={agregarAval2} onChange={handleRadioChange}>
                                <FormControlLabel value="si" control={<Radio color="error" variant="solid" />} label="Sí" />
                                <FormControlLabel value="no" control={<Radio color="error" variant="solid" />} label="No" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                    {agregarAval2 === 'si' && (
                        <>
                            <Aval2
                                selectedIdentidadAval2={selectedIdentidadAval2}
                                setselectedIdentidadAval2={setselectedIdentidadAval2}
                                selectedVoucherIdentidadAval2={selectedVoucherIdentidadAval2}
                                setselectedVoucherIdentidadAval2={setselectedVoucherIdentidadAval2}
                            />
                            <Divider style={{ marginTop: 5 }} />
                        </>
                    )}
                </>}

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '20vh', // Establece la altura de la caja para ocupar toda la pantalla verticalmente
                    }}
                >
                    <Grid item>
                        <Button
                            onClick={validateErrors}
                            endIcon={<SendIcon />}
                            variant="contained"
                            color="success"
                            size="large"
                        >
                            <span>Enviar Solicitud</span>
                        </Button>
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={open}
                        //onClick={handleClose}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </Grid>
                    <Dialog open={openDialog} onClose={handleCloseDialog}>
                        <DialogTitle>{"Enviado"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description" align='justify'>
                                Los datos fueron enviados con éxito.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialog} variant='contained' startIcon={< CheckCircleOutlineIcon />} color="success">
                                Aceptar
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog open={openDialogErrores} onClose={handleCloseDialogErrores}>
                        <DialogTitle>
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <ReportProblemIcon style={{ marginRight: '5px', color: 'var(--color-brand-secondary)' }} />
                                Error de Validación
                                <ReportProblemIcon style={{ marginLeft: '5px', color: 'var(--color-brand-secondary)' }} />
                            </span>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Hay errores en el formulario. Por favor, corríjalos antes de enviar.
                            </DialogContentText>
                            <Divider></Divider>
                            <ul>
                                {Object.entries(errors).map(([fieldName, errorMessage]) => (
                                    <li key={fieldName}>{errorMessage}</li>
                                ))}
                            </ul>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialogErrores} variant='contained' startIcon={< CheckCircleOutlineIcon />} color="success">
                                Aceptar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </Container>
        </div>

    </>)
}

export default SolicitudSimplificada;
